// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal--dialog .modal--fill {
  position: relative;
  max-width: calc(100vw - 24px);
  margin: auto;

  background-color: white;

  border: 1px solid #1a6a7c;
  border-radius: 20px;
  box-sizing: border-box;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.15), 0 6px 40px 0 rgba(0, 0, 0, 0.15);

  z-index: 100;
}

.modal--dialog * {
  font-family: "Manrope";
  font-size: 15px;
}

.modal--dialog .modal--header {
  position: relative;
  font-family: "Amatic SC", cursive;
  font-size: 24pt;
  text-align: center;
  padding: 26px 44px 0;
}
.modal--dialog .modal--body {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 10px;
}

.modal--dialog .modal--body * {
  box-sizing: border-box;
  width: 280px;
}

.modal--dialog .modal--body div {
  margin-top: 10px;
}

.modal--dialog .modal--body div input,
.modal--dialog .modal--body div select {
  margin: 4px 0px;
  border: 0;
  font-weight: 500;
  padding: 0 17.5px;
  height: 40px;
  outline: 0;
  border-radius: 10px;
  border: 1px solid #1a6a7c;
}

.modal--dialog .modal--footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  margin: 4px auto 18px;
}

.modal--dialog .auth-form input,
.modal--dialog .auth-form input::placeholder {
  font-family: "Phenoma Light", "Segoe UI", Arial, sans-serif;
  font-size: calc(15px + 4pt);
}

.modal--dialog button {
  font-family: "Phenoma Light", "Segoe UI", Arial, sans-serif;
  font-size: calc(20px + 2pt);
}

.modal--dialog .modal--footer a {
  font-family: "Phenoma Light", "Segoe UI", Arial, sans-serif;
  font-size: calc(15px + 2pt);
  font-weight: 300;
  margin-top: 4px;
}

.modal--dialog .modal--footer a:hover {
  cursor: pointer;
  transform: scale(1.1);
  transition-duration: 200ms;
}

.modal--dialog .modal--body p {
  text-align: center;
}

.modal--dialog .modal--body h3 {
  text-align: center;
}

.modal--dialog .auth-form label,
.modal--dialog .auth-form p {
  font-family: "Phenoma Light", "Segoe UI", Arial, sans-serif;
  font-size: calc(15px + 2pt);
}

.modal--dialog .auth-form .modal--header {
  font-family: "Phenoma Light", "Segoe UI", Arial, sans-serif;
}

.modal--dialog .auth-form label {
  display: block;
  text-align: left;
  line-height: 1.2;
}

.modal--dialog .auth-form .custom-button { margin: 4px 0; }
.modal--dialog .auth-form .modal--body { padding-bottom: 16px; }
.modal--dialog .auth-form .modal--body * { max-width: 100%; }

.modal--dialog .dialog-close {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
  display: grid;
  place-items: center;
  width: 36px;
  height: 36px;
  padding: 0;
  margin: 0;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #1a6a7c;
  cursor: pointer;
}
.modal--dialog .dialog-close span { font: 28px/1 Arial, sans-serif; }
.modal--dialog .dialog-close:hover { background: #eefaf7; transform: none; }
.modal--dialog .dialog-close:focus-visible { outline: 2px solid #1a6a7c; outline-offset: 2px; }

.modal--dialog .registration-error,
.modal--dialog .login-error {
  padding: 12px;
  border: 1px solid #c47979;
  border-radius: 10px;
  background: #fff3f3;
  color: #8b2930;
}
.modal--dialog .registration-error p,
.modal--dialog .login-error p {
  margin: 0 0 8px;
  text-align: left;
}
.modal--dialog .registration-error a,
.modal--dialog .login-error a {
  font-family: "Phenoma Light", "Segoe UI", Arial, sans-serif;
  font-size: calc(15px + 2pt);
  text-decoration: underline;
}

.modal--dialog .registration-success {
  padding: 16px;
  border: 1px solid #4fa799;
  border-radius: 10px;
  background: #eefaf7;
  color: #1a6a7c;
}
.modal--dialog .registration-success p { margin: 0 0 8px; }
.modal--dialog .registration-success p:last-child { margin-bottom: 0; }

.modal--dialog .auth-form .password-field {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 36px;
  align-items: center;
  margin: 4px 0;
  border: 1px solid #1a6a7c;
  border-radius: 10px;
  overflow: hidden;
}
.modal--dialog .auth-form .password-field input {
  width: 100%; min-width: 0; height: 38px;
  margin: 0; border: 0; border-radius: 0;
}
.modal--dialog .auth-form .password-toggle {
  display: grid; place-items: center;
  width: 36px; height: 38px; margin: 0; padding: 0;
  border: 0; background: transparent; color: #1a6a7c; cursor: pointer;
}
.modal--dialog .auth-form .password-toggle svg { width: 20px; height: 20px; }
.modal--dialog .auth-form .password-toggle:hover { background: #eefaf7; transform: none; }
.modal--dialog .auth-form .password-field:focus-within { outline: 2px solid #1a6a7c; outline-offset: 2px; }
`, "",{"version":3,"sources":["webpack://./src/Components/DialogModal.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;;EAEZ,uBAAuB;;EAEvB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,8EAA8E;;EAE9E,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;;EAEE,2DAA2D;EAC3D,2BAA2B;AAC7B;;AAEA;EACE,2DAA2D;EAC3D,2BAA2B;AAC7B;;AAEA;EACE,2DAA2D;EAC3D,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,2DAA2D;EAC3D,2BAA2B;AAC7B;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,2CAA2C,aAAa,EAAE;AAC1D,yCAAyC,oBAAoB,EAAE;AAC/D,2CAA2C,eAAe,EAAE;;AAE5D;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;AACA,oCAAoC,8BAA8B,EAAE;AACpE,qCAAqC,mBAAmB,EAAE,eAAe,EAAE;AAC3E,6CAA6C,0BAA0B,EAAE,mBAAmB,EAAE;;AAE9F;;EAEE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;AACA;;EAEE,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,2DAA2D;EAC3D,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;AACA,yCAAyC,eAAe,EAAE;AAC1D,oDAAoD,gBAAgB,EAAE;;AAEtE;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW,EAAE,YAAY,EAAE,YAAY;EACvC,SAAS,EAAE,SAAS,EAAE,gBAAgB;AACxC;AACA;EACE,aAAa,EAAE,mBAAmB;EAClC,WAAW,EAAE,YAAY,EAAE,SAAS,EAAE,UAAU;EAChD,SAAS,EAAE,uBAAuB,EAAE,cAAc,EAAE,eAAe;AACrE;AACA,iDAAiD,WAAW,EAAE,YAAY,EAAE;AAC5E,mDAAmD,mBAAmB,EAAE,eAAe,EAAE;AACzF,yDAAyD,0BAA0B,EAAE,mBAAmB,EAAE","sourcesContent":[".modal--dialog .modal--fill {\n  position: relative;\n  max-width: calc(100vw - 24px);\n  margin: auto;\n\n  background-color: white;\n\n  border: 1px solid #1a6a7c;\n  border-radius: 20px;\n  box-sizing: border-box;\n  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.15), 0 6px 40px 0 rgba(0, 0, 0, 0.15);\n\n  z-index: 100;\n}\n\n.modal--dialog * {\n  font-family: \"Manrope\";\n  font-size: 15px;\n}\n\n.modal--dialog .modal--header {\n  position: relative;\n  font-family: \"Amatic SC\", cursive;\n  font-size: 24pt;\n  text-align: center;\n  padding: 26px 44px 0;\n}\n.modal--dialog .modal--body {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  padding: 10px;\n}\n\n.modal--dialog .modal--body * {\n  box-sizing: border-box;\n  width: 280px;\n}\n\n.modal--dialog .modal--body div {\n  margin-top: 10px;\n}\n\n.modal--dialog .modal--body div input,\n.modal--dialog .modal--body div select {\n  margin: 4px 0px;\n  border: 0;\n  font-weight: 500;\n  padding: 0 17.5px;\n  height: 40px;\n  outline: 0;\n  border-radius: 10px;\n  border: 1px solid #1a6a7c;\n}\n\n.modal--dialog .modal--footer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-evenly;\n  margin: 4px auto 18px;\n}\n\n.modal--dialog .auth-form input,\n.modal--dialog .auth-form input::placeholder {\n  font-family: \"Phenoma Light\", \"Segoe UI\", Arial, sans-serif;\n  font-size: calc(15px + 4pt);\n}\n\n.modal--dialog button {\n  font-family: \"Phenoma Light\", \"Segoe UI\", Arial, sans-serif;\n  font-size: calc(20px + 2pt);\n}\n\n.modal--dialog .modal--footer a {\n  font-family: \"Phenoma Light\", \"Segoe UI\", Arial, sans-serif;\n  font-size: calc(15px + 2pt);\n  font-weight: 300;\n  margin-top: 4px;\n}\n\n.modal--dialog .modal--footer a:hover {\n  cursor: pointer;\n  transform: scale(1.1);\n  transition-duration: 200ms;\n}\n\n.modal--dialog .modal--body p {\n  text-align: center;\n}\n\n.modal--dialog .modal--body h3 {\n  text-align: center;\n}\n\n.modal--dialog .auth-form label,\n.modal--dialog .auth-form p {\n  font-family: \"Phenoma Light\", \"Segoe UI\", Arial, sans-serif;\n  font-size: calc(15px + 2pt);\n}\n\n.modal--dialog .auth-form .modal--header {\n  font-family: \"Phenoma Light\", \"Segoe UI\", Arial, sans-serif;\n}\n\n.modal--dialog .auth-form label {\n  display: block;\n  text-align: left;\n  line-height: 1.2;\n}\n\n.modal--dialog .auth-form .custom-button { margin: 4px 0; }\n.modal--dialog .auth-form .modal--body { padding-bottom: 16px; }\n.modal--dialog .auth-form .modal--body * { max-width: 100%; }\n\n.modal--dialog .dialog-close {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  z-index: 1;\n  display: grid;\n  place-items: center;\n  width: 36px;\n  height: 36px;\n  padding: 0;\n  margin: 0;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: #1a6a7c;\n  cursor: pointer;\n}\n.modal--dialog .dialog-close span { font: 28px/1 Arial, sans-serif; }\n.modal--dialog .dialog-close:hover { background: #eefaf7; transform: none; }\n.modal--dialog .dialog-close:focus-visible { outline: 2px solid #1a6a7c; outline-offset: 2px; }\n\n.modal--dialog .registration-error,\n.modal--dialog .login-error {\n  padding: 12px;\n  border: 1px solid #c47979;\n  border-radius: 10px;\n  background: #fff3f3;\n  color: #8b2930;\n}\n.modal--dialog .registration-error p,\n.modal--dialog .login-error p {\n  margin: 0 0 8px;\n  text-align: left;\n}\n.modal--dialog .registration-error a,\n.modal--dialog .login-error a {\n  font-family: \"Phenoma Light\", \"Segoe UI\", Arial, sans-serif;\n  font-size: calc(15px + 2pt);\n  text-decoration: underline;\n}\n\n.modal--dialog .registration-success {\n  padding: 16px;\n  border: 1px solid #4fa799;\n  border-radius: 10px;\n  background: #eefaf7;\n  color: #1a6a7c;\n}\n.modal--dialog .registration-success p { margin: 0 0 8px; }\n.modal--dialog .registration-success p:last-child { margin-bottom: 0; }\n\n.modal--dialog .auth-form .password-field {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 36px;\n  align-items: center;\n  margin: 4px 0;\n  border: 1px solid #1a6a7c;\n  border-radius: 10px;\n  overflow: hidden;\n}\n.modal--dialog .auth-form .password-field input {\n  width: 100%; min-width: 0; height: 38px;\n  margin: 0; border: 0; border-radius: 0;\n}\n.modal--dialog .auth-form .password-toggle {\n  display: grid; place-items: center;\n  width: 36px; height: 38px; margin: 0; padding: 0;\n  border: 0; background: transparent; color: #1a6a7c; cursor: pointer;\n}\n.modal--dialog .auth-form .password-toggle svg { width: 20px; height: 20px; }\n.modal--dialog .auth-form .password-toggle:hover { background: #eefaf7; transform: none; }\n.modal--dialog .auth-form .password-field:focus-within { outline: 2px solid #1a6a7c; outline-offset: 2px; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
